import { useCallback } from 'react'

import { ThirdPartyLogApplication } from 'onboarding/classes/models/thirdPartyLog'
import { thirdPartyLogService } from 'onboarding/services/thirdPartyLogService'

import { ThirdPartyLogButton } from './ThirdPartyLogButton'

interface IProps {
  caption: string
  partnerId: string
}

export const PartnerThirdPartyLogButton = ({ caption, partnerId }: IProps) => {
  const fetchApplications = useCallback(
    () => thirdPartyLogService.fetchApplicationsByPartnerId(partnerId),
    [partnerId]
  )
  const createApplicationLogsCrud = useCallback(
    (application: ThirdPartyLogApplication) =>
      thirdPartyLogService.getCrudApplicationLogsByPartnerId({
        application,
        partnerId,
      }),
    [partnerId]
  )

  return (
    <ThirdPartyLogButton
      caption={caption}
      createApplicationLogsCrud={createApplicationLogsCrud}
      fetchApplications={fetchApplications}
    />
  )
}
